import React, { Fragment, useEffect, useState } from "react";
import { get } from "../../effects/api/api.common";
import { GET_PORTFOLIO_DETAIL } from "../../constants/api";
import LeftArrow from '../../images/LeftArrow.svg';
import RightArrow from '../../images/RightArrow.svg';
const PortfolioDetail = (props: any) => {


    const [data, setData] = useState<any>({})
    const [portfolioId, sePortfolioID] = useState('')
    const [showMore, setShowMore] = useState(false)

    const getPortFolioDetail = (id: any) => {
        // change url based on url id hardcoded just because of one data
        const url = GET_PORTFOLIO_DETAIL + id
        get(url).then((response: any) => {
            if (!response || !response.data) return;
            if (response?.data?.result === 'success') {
                // console.log('data', response.data.data)
                setData(response.data.data)
            } else {
                setData({})
            }

        })
    }

    useEffect(() => {

        if ((typeof props.location.state !== 'undefined') && (props.location.state != null)) {
            if (props.location.state.portfolioId) {

                sePortfolioID(props.location.state.portfolioId)
                getPortFolioDetail(props.location.state.portfolioId);
            }


        }
    }, [])

    return (
        <Fragment>

            {Object.keys(data).length > 0 &&
                <div className="container mt-5 mb-5 portfolio-detail-container">
                    <div className="col-md-12">

                        <div className="d-flex justify-content-between mb-4">
                            <div className="logo">
                                <img src={data.logo} alt={data.incubator_name} className="portLogo" />
                            </div>
                            <div className="website">
                                <button className="btn btn-sisfs btn-transparent-primary mt-4" onClick={() => window.open(data.site_url)}>
                                    Visit Website
                                </button>
                            </div>
                        </div>


                        <h1 className="main-heading portDetailHeading">{data.incubator_name}</h1>

                        <div className="col-md-12">
                            <div className="row">
                                <p className="portCity mr-1 pt-1">{data.city},{' ' + data.state}|</p>
                                {!showMore &&
                                <p className="portTagDetail ml-4">
                                    {data.sectors.length > 0 && data?.sectors.map((sector: string, index: number) => {
                                       if(index<4){
                                        return (
                                            <Fragment key={index}>
                                                <span className="mr-1">{sector}</span>
                                            </Fragment>
                                        )
                                        }
                                    })}                                 

                                </p>}
                                {showMore &&
                                <p className="portTagDetail ml-4">
                                    {data.sectors.length > 0 && data?.sectors.map((sector: string, index: number) => {
                                        return (
                                            <Fragment key={index}>
                                                <span className="mr-1">{sector}</span>
                                            </Fragment>
                                        )
                                    })}                                 

                                </p>}
                                {!showMore && (data.sectors.length>4) &&<span className="link-orange-text d-block pt-1 pl-3" onClick={() => setShowMore(true)}>View More</span>}
                            </div>

                            <div className="mainImage">
                                <img src={data.image} alt={data.incubator_name} className="portImageMain" />
                            </div>
                        </div>


                        {/* <div className="portImageBlock">
                            <img src="" className="portImage" />
                        </div> */}

                        <div className="main-heading right-heading mt-4">About</div>
                        <p className="para-text mb-2">
                            {data.description}
                        </p>


                        <div className="main-heading right-heading mt-5">Key Features</div>

                        <div className="key">
                            <div className="ordered-list wrapper about-ordered-list">
                                <ol>
                                    {data.key_features.length > 0 && data.key_features.map((feature: string, index: number) => {
                                        return (
                                            <Fragment key={index}>
                                                <li>
                                                    {feature}
                                                </li>
                                            </Fragment>
                                        )
                                    })}
                                </ol>
                            </div>

                        </div>

                        <div className="main-heading text-center mt-5 mb-4">Photo Gallery</div>
                        <div>

                            <div id="carouselExampleIndicators" className="carousel" data-ride="carousel">
                                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <ol className="carousel-indicators">
                                    {data.images_data.map((image: string, index: number) => {
                                        if (index == 0) {
                                            return (
                                                <li data-target="#carouselExampleIndicators" data-slide-to={index} className="active" key={index}></li>
                                            )
                                        }
                                        else {
                                            return (
                                                <li data-target="#carouselExampleIndicators" data-slide-to={index} key={index}></li>
                                            )
                                        }
                                    })}
                                    {/* <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li> */}
                                </ol>
                                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="sr-only">Next</span>
                                </a>

                                <div className="carousel-inner carousel-overflow">
                                    {data.images_data.map((image: string, index: number) => {
                                        if (index == 0) {
                                            return (
                                                <div className="carousel-item active" key={index}>
                                                    <img className="d-block w-100 corousel-image" src={image} alt="First slide" />
                                                </div>
                                            )
                                        }
                                        else {
                                            return (
                                                <div className="carousel-item" key={index}>
                                                    <img className="d-block w-100 corousel-image" src={image} alt="First slide" />
                                                </div>
                                            )
                                        }

                                    })}
                                    {/* <div className="carousel-item active">
                                        <img className="d-block w-100" src={data.image} alt="First slide" />
                                    </div>
                                    <div className="carousel-item">
                                        <img className="d-block w-100" src={data.image} alt="Second slide" />
                                    </div>
                                    <div className="carousel-item">
                                        <img className="d-block w-100" src={data.image} alt="Third slide" />
                                    </div> */}



                                </div>



                            </div>

                        </div>
                        <div className="text-center">
                            <button className="btn btn-sisfs btn-transparent-primary mt-4" onClick={() => window.open(data.site_url)}>
                                Visit Website
                            </button>
                        </div>

                    </div>
                </div>
            }

        </Fragment>
    )
}

export default PortfolioDetail
